import * as React from 'react'
import loadable from '@loadable/component'

const SvgAccountIcon = loadable(
  () =>
    import(
      '@thg-commerce/gravity-icons/src/components/AccountIcons/AccountIcon'
    ),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

import { AccountIconWrapper, SubmenuAccountIcon } from '../styles'

export const AccountDropdownIcon = ({
  accountIcon,
}: {
  accountIcon: string
}) => {
  return (
    <AccountIconWrapper>
      {accountIcon ? (
        <SubmenuAccountIcon
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 47.43 47.43"
        >
          <path d={accountIcon}></path>
        </SubmenuAccountIcon>
      ) : (
        <SvgAccountIcon />
      )}
    </AccountIconWrapper>
  )
}
